// Use https://www.color-blindness.com/color-name-hue to name the colour
export default {
  orange: '#f2aa02',
  darkTangerine: '#fdb717',
  goldenTainoi: '#fdc951',
  grandis: '#ffd76b',
};
